@if (!Spinner.isShown(column)) {
    <div class="cell"
         [ngClass]="row | camelToKebab"
         [class.bordered]="column === 'quarter' || column === 'month'"
         [class.disabled]="column === 'forecastFuture'"
         [class.alert]="hasAlert"
         fxLayout="column" fxLayoutAlign="center start">
        @if (column === 'forecastPast') {
            <div class="marker"
                 [class.alert]="hasAlert"></div>
        }
        @for (cell of viewModelData; track cell; let index = $index; let first = $first) {
            @if (maxDataRows && viewModelData?.length > maxDataRows) {
                @if (index < maxDataRows) {
                    <ng-container [ngTemplateOutlet]="cellData" [ngTemplateOutletContext]="{cell, first}"/>
                } @else if (index === maxDataRows) {
                    <div class="more" (click)="showMoreClickListener.emit()">{{ 'i18n_af_buttonReadMore' | translate }}</div>
                }
            } @else {
                <ng-container [ngTemplateOutlet]="cellData" [ngTemplateOutletContext]="{cell, first}"/>
            }
        }
    </div>
} @else {
    <ngx-skeleton-loader [ngClass]="row | camelToKebab"
                         [theme]="skeletonConfig"/>
}

<ng-template #cellData let-cell="cell" let-first="first">
    <div [class.grid]="labelLayoutType === 'grid'"
         [class.column]="labelLayoutType === 'column'"
         [class.flex]="maxDataRows === 1"
         [class.mt-8]="!first">
        @if (cell.label) {
            <div class="label">
                {{ (translationPostfix ? 'i18n_af_labelClassificationTableCell' + translationPostfix + '#' + cell.label : cell.label) | translate }}
            </div>
        }
        <div class="value"
             [class.text-center]="!cell.label"
             [class.alert]="cell.hasAlert">
            @if (!!cell.value || !!cell.count) {
                @if (dataType === 'percentage') {
                    {{ cell.value }}%
                } @else if (dataType === 'count') {
                    {{ cell.count | numberTriplesFormat }}
                } @else if (dataType === 'money') {
                    {{ cell.count | tiynTenge | numberTriplesFormat }}
                } @else {
                    {{ cell.value }}
                }
            } @else {
                {{ 'i18n_af_emptyStateTitleNoData' | translate }}
            }
        </div>
    </div>
</ng-template>
